import { useQuery } from "hooks/useQuery";
import { getFaqs } from "../service";

export const useFaqs = () => {
  const { isLoading, data } = useQuery({
    queryKey: ["faqs"],
    queryFn: async () => {
      const response = await getFaqs();
      return response.map((d) => ({
        title: d.title,
        body: d.description,
      }));
    },
  });

  return {
    isLoading,
    faqs: data || [],
  };
};
